import script from "./StatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusBadge.vue?vue&type=script&setup=true&lang=js"

import "./StatusBadge.vue?vue&type=style&index=0&id=6508a910&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6508a910"]])

export default __exports__